import { createServiceClient } from 'utils/apiClient'

const scheduleCreate = createServiceClient('/schedule')

export default scheduleCreate
